import { Box, Checkbox as NBCheckbox, FormControl, IBoxProps } from 'native-base';
import React, { ReactNode } from 'react';

import { tID } from 'app/services/TestHelper';

export type CheckboxProps = {
  children: ReactNode;
  value: string;
  accessibilityLabel: string;
  isChecked: boolean;
  isRequired?: boolean;
  onChange: (isSelected: boolean) => void;
} & IBoxProps;

export default function Checkbox({
  value,
  accessibilityLabel,
  isChecked,
  isRequired,
  onChange,
  children,
  ...props
}: CheckboxProps) {
  return (
    <Box rounded="md" {...props} testID={tID('Checkbox')}>
      <FormControl isRequired={isRequired}>
        <NBCheckbox
          _stack={{ alignItems: 'flex-start' }}
          accessibilityLabel={accessibilityLabel}
          isChecked={isChecked}
          value={value}
          onChange={onChange}
        >
          <Box flexShrink="1" px={2}>
            {children}
          </Box>
        </NBCheckbox>
      </FormControl>
    </Box>
  );
}
